import { render, staticRenderFns } from "./ui-icon.vue?vue&type=template&id=1d8c587d&"
import script from "./ui-icon.vue?vue&type=script&lang=js&"
export * from "./ui-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports